// NEW APP TODO – Replace with the appropriate links for your application.
export const EXTERNAL_LINKS = {
  TERMS: "https://google.com/terms",
  PRIVACY: "https://google.com/privacy",
  DISCLAIMER: "https://google.com/disclaimer",
  APPLE_STORE_APP: "https://apple.com",
  GOOGLE_PLAY_STORE_APP: "https://google.com",
};
